<div class="lg:p-4 w-full relative" *ngIf="!['', null, undefined].includes(responseDetailsRooms);else loading">
    <div class="w-full flex  lg:justify-start justify-start p-4 lg:p-0">
        <i class="ico-Close cursor-pointer lg:hidden block ml-3 text-xl" (click)="closeModal()"></i>
        <i class="ico-Close cursor-pointer lg:block hidden text-xl" (click)="closeModal()"></i>
        <h3 class="text-lg mb-3 mx-2">جزئیات اتاق</h3>
    </div>
    <div class="flex gap-2 flex-wrap lg:flex-nowrap  h-[88vh] overflow-y-auto lg:h-auto lg:overflow-visible">
        <div class="block lg:hidden w-full relative">
            <div class="w-full flex flex-col justify-center items-center {{showEmpty ? '' : 'h-[55vh]'}}"
                *ngIf="showEmpty">
                <img [src]="cdnUrl + '/images/no-rooms.jpg'" class="mb-3 mx-auto object-contain" height="150"
                    width="100%" alt="واحد اقامتی پیدا نشد">
            </div>
            <!-- swiper slider -->
            <div *ngIf="!showEmpty"
                class="absolute bg-black-500 px-3 py-1 rounded right-[10px] bottom-[10px] text-white z-20 flex gap-1 items-center">
                <span> {{realIndexSlider}}</span>
                <span>از</span>
                <span>{{responseDetailsRooms?.slider.length}}</span>

            </div>
            <swiper (slideChange)="onSlideChange($event)" *ngIf="!showEmpty" [config]="configSwiperGallery"
                #swiperGalleryRoom id="swiperGalleryRoom">
                <ng-template swiperSlide *ngFor="let item of responseDetailsRooms?.slider;let index = index"
                    class="w-full h-[200px]">
                    <img [ngSrc]="item.url" fill (error)="item.url = cdnUrl + '/images/no-image.jpg'"
                        class="lg:rounded-xl cursor-pointer w-full h-full object-cover" [alt]="item.alt">
                </ng-template>
            </swiper>
        </div>

        <div class="lg:w-[70%] w-full lg:h-[57vh] lg:min-h-[470px] lg:overflow-y-auto p-1 lg:block hidden">
            <div class="w-full flex flex-col justify-center items-center h-[55vh]" *ngIf="showEmpty">
                <img src="https://cdn.iranhotelonline.com/images/no-rooms.jpg" class="mb-3 mx-auto object-contain"
                    height="150" width="100%" alt="واحد اقامتی پیدا نشد">
            </div>


            <div class="img-item-room  mb-2 lg:mb-0 "
                *ngFor="let item of responseDetailsRooms?.slider;let index = index">
                <img [ngSrc]="item.url" [height]="item.height" [width]="item.width" [alt]="item.alt"
                    (error)="item.url = cdnUrl + '/images/no-image.jpg'"
                    class="lg:rounded-xl cursor-pointer w-full mb-3 object-cover">
            </div>
        </div>
        <div class="lg:w-[30%] w-full p-3 lg:p-1 relative">
            <h4 class="mb-5">{{responseDetailsRooms?.info?.roomInfoFacility?.roomName}}</h4>
            <div class="w-full  lg:h-[51vh] lg:min-h-[470px] lg:overflow-y-auto pb-[70px] lg:pb-[45px]">
                <ul class="">
                    <li class=" mb-3 gap-1">
                        <div class="flex items-center">
                            <i class="ico-Profile text-xl text-black-300 ml-2"></i>

                            <span class="text-muted text-sm md:text-xs lg:text-sm">
                                {{modalData.roomInfo?.roomCapacity?.adultCapacity}} بزرگسال،
                                {{modalData.roomInfo?.roomCapacity?.infantCapacity}} خردسال
                            </span>

                        </div>
                        <p class="text-sm text-black-200">برای اطلاعات بیشتر درباره پذیرش خردسال، به بخش قوانین و مقررات
                            مراجعه کنید.</p>
                    </li>
                    <li class="gap-1" *ngIf="modalData.roomInfo?.roomCapacity?.extraCapacity">
                        <div class="flex items-center">
                            <i class="ico-ProfileAdd text-2xl text-black-300 ml-2"></i>
                            <span class="text-muted text-sm md:text-xs lg:text-sm">
                                قابلیت نفر اضافه دارد </span>
                            <span *ngIf="modalData.roomInfo?.roomCapacity?.extraCapacityPrice"
                                class="bg-gray-200 text-metal-500 text-sm font-medium mr-2 px-2.5 py-0.5 rounded">
                                هر نفر{{modalData.roomInfo?.roomCapacity?.extraCapacityPrice | toToman | number: '2.'}}
                                تومان
                            </span>
                        </div>


                        <p class="text-sm text-black-200">
                            اتاق علاوه بر ظرفیت پایه امکان پذیرش {{modalData.roomInfo?.roomCapacity?.extraCapacity}} نفر
                            اضافه را دارد.
                        </p>
                        <p class="text-sm text-black-200 mb-3">
                            برای استفاده, پس از انتخاب اتاق و اقدام به ررزو در مرحله درج اطلاعات بخش مربوطه را کامل
                            کنید.
                        </p>
                    </li>


                    <li class="flex items-center gap-1 mb-3">
                        <i class="ico-Breakfast text-2xl text-black-300"></i>

                        <span *ngIf="modalData.roomInfo?.roomDetail?.lunch || modalData.roomInfo?.roomDetail?.dinner"
                            class="text-muted text-sm md:text-xs lg:text-sm flex">

                            <span *ngIf="modalData.roomInfo?.roomDetail?.lunch">
                                {{modalData.roomInfo?.roomDetail?.lunch ? ' ناهار' : ''}}
                            </span>
                            <span
                                *ngIf="modalData.roomInfo?.roomDetail?.dinner && modalData.roomInfo?.roomDetail?.lunch"
                                class="mx-2"> + </span>
                            <span *ngIf="modalData.roomInfo?.roomDetail?.dinner">
                                {{modalData.roomInfo?.roomDetail?.dinner ? ' شام' : ''}}
                            </span>
                            <span
                                *ngIf="modalData.roomInfo?.roomDetail?.dinner || modalData.roomInfo?.roomDetail?.lunch"
                                class="mx-2"> + </span>
                        </span>
                        <span class="flex items-center lg:text-sm md:text-xs text-muted text-sm w-full">

                            صبحانه
                            <span *ngIf="!modalData.roomInfo?.roomDetail?.breakfast"
                                class="bg-gray-200 mx-1 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded">

                                ندارد
                            </span>
                            <div class="flex items-center justify-center flex-wrap mr-2"
                                *ngIf="modalData.roomInfo?.roomDetail?.breakfast && modalData?.breakFastType?.length">
                                <span *ngFor="let item of modalData?.breakFastType"
                                    class="bg-gray-200 whitespace-nowrap mb-2 text-metal-500 text-sm font-medium mx-1 px-2.5 py-0.5 rounded">
                                    {{item?.name}}
                                </span>

                            </div>

                        </span>


                    </li>



                    <li class="flex items-center mb-3 gap-1" *ngIf="modalData.roomInfo?.roomDetail?.nonRefundable">
                        <i class="ico-Close text-xl text-black-300"></i>
                        <span class="text-muted text-sm md:text-xs lg:text-sm">بدون بازگشت وجه</span>
                    </li>
                    <li class=" mb-3 gap-1" *ngIf="modalData?.isHourly">
                        <div class="flex items-center">
                            <i class="ico-TimeCircle text-2xl text-black-300"></i>
                            <span class="text-muted text-sm md:text-xs lg:text-sm mr-2">رزرو
                                ساعتی</span>

                        </div>
                        <p class="text-sm text-black-200">
                            رزرو این اتاق تنها به صورت ساعتی امکان پذیر است.
                        </p>
                    </li>

                </ul>
                <h6 class="my-3">اطلاعات اتاق</h6>
                <p class="text-black-300 text-sm mb-3">{{responseDetailsRooms?.info?.description}}</p>
                <ul>
                    <li *ngIf="responseDetailsRooms?.info?.bathroomQuantity > 0 && responseDetailsRooms?.roomWards[0].hasBathroom" class="flex items-center">
                        <i class="ico-Checkmark text-2xl text-black-300"></i>
                        <span class="text-sm text-black-300 !font-medium"> تعداد حمام : </span>
                        <!-- <span class="text-sm text-black-300 mr-2"
                         *ngIf="responseDetailsRooms?.roomWards[0].hasBathroom && responseDetailsRooms?.info?.bathroomQuantity != 0">
                         {{responseDetailsRooms?.info?.bathroomQuantity}}
                          حمام اختصاصی 
                        </span> -->
                         <span class="text-sm text-black-300 !font-medium">
                            {{responseDetailsRooms?.info?.bathroomQuantity}} حمام </span>
                        <!-- <span class="text-sm text-black-300 mr-2">
                            {{(responseDetailsRooms?.roomWards[0].hasBathroom &&
                            responseDetailsRooms?.info?.bathroomQuantity == 1) ? '2 ' :
                            responseDetailsRooms?.info?.bathroomQuantity + 'حمام'}}
                        </span> -->
                    </li>
                    <li *ngIf="responseDetailsRooms?.info?.bedroomQuantity > 0" class="flex items-center">
                        <i class="ico-Checkmark text-2xl text-black-300"></i>
                        <span class="text-sm text-black-300 !font-medium">تعداد خواب : </span>
                        <span class="text-sm text-black-300 mr-2">
                            (ظرفیت {{responseDetailsRooms?.info?.bedroomQuantity}} نفر)
                        </span>
                    </li>
                    <li *ngIf="responseDetailsRooms?.info?.livingRoomQuantity > 0" class="flex items-center">
                        <i class="ico-Checkmark text-2xl text-black-300"></i>
                        <span class="text-sm text-black-300 !font-medium">تعداد پذیرایی : </span>
                        <span class="text-sm text-black-300 mr-2">
                            (ظرفیت {{responseDetailsRooms?.info?.livingRoomQuantity}} نفر)
                        </span>
                    </li>
                    <li class="mb-3" *ngIf="responseDetailsRooms?.info?.roomInfoFacility?.bedType">
                        <i class="ico-RoomSize text-black-300 ml-2"></i>
                        <span>نوع تخت: </span>
                        <span class="text-black-300 mx-2 text-sm">(
                            {{responseDetailsRooms?.info?.roomInfoFacility?.bedType}} </span>

                        )
                    </li>
                    <li class="mb-3" *ngIf="responseDetailsRooms?.info?.roomInfoFacility?.roomSize">
                        <i class="ico-RoomSize text-black-300 ml-2"></i>
                        <span>سایز اتاق: </span>
                        <span class="text-black-300 mx-2 text-sm">(
                            {{responseDetailsRooms?.info?.roomInfoFacility?.roomSize}} متر مربع</span>

                        )
                    </li>
                    <li class="mb-3" *ngIf="responseDetailsRooms?.info?.roomInfoFacility?.bedSize">
                        <i class="ico-BedSize text-black-300 ml-2"></i>
                        <span>سایز تخت: </span>
                        <span class="text-black-300 mx-2 text-sm">(
                            {{responseDetailsRooms?.info?.roomInfoFacility?.bedSize}} سانتی متر</span>

                        )
                    </li>
                </ul>
                <ng-container *ngIf="responseDetailsRooms?.info?.roomInfoFacility?.beds?.length">
                    <h6 class="mb-3">امکانات اتاق</h6>

                    <ul class="list-[inherit]">
                        <li *ngFor="let item of responseDetailsRooms?.info?.roomInfoFacility?.beds"
                            class="relative mb-3 mr-5">
                            <span class="text-black-300 text-sm"> {{item.quantity}} </span>
                            <span class="text-black-300 mx-2 text-sm"> {{item.type}} </span>
                            <span class="text-black-300 mx-2 text-sm">({{item.size}} سانتی متر مربع) </span>

                        </li>
                    </ul>

                </ng-container>

                <ng-container *ngIf="responseDetailsRooms?.roomWards?.length">
                    <h6 class="mb-3">سایز تخت و ترکیب تخت ها </h6>

                    <ul class="">
                        <li *ngFor="let item of responseDetailsRooms?.roomWards" class="relative mb-3">
                            <i class="ico-BedSize text-black-300 ml-2"></i>
                            <span *ngIf="item.name" class="text-black-300 text-sm"> {{item.name}} </span>
                            <span *ngIf="item.size" class="text-black-300 mx-2 text-sm">({{item.size}} سانتی متر مربع)
                            </span>

                        </li>
                    </ul>

                </ng-container>

                <ng-container *ngFor="let item of responseDetailsRooms?.info?.roomFacilityCat">
                    <h6 class="mb-3">{{item.name}}</h6>
                    <ul class="list-[inherit]">
                        <li *ngFor="let facility of item.facilities;let index = index" class="relative mb-3 mr-5">
                            <span class="text-black-300 mx-2 text-sm">{{facility}}</span>

                        </li>
                    </ul>
                </ng-container>
                <ng-container *ngIf="responseDetailsRooms?.info?.roomInfoFacility?.topRoomFacility">
                    <h6 class="mb-3"> امکانات برتر اتاق</h6>
                    <ul class="list-[inherit]">
                        <li *ngFor="let item of responseDetailsRooms?.info?.roomInfoFacility?.topRoomFacility"
                            class="relative mb-3 mr-5 flex">
                            <div [innerHTML]="item.svgPic | bypassHtmlSanitizer" class="w-[20px]"></div>
                            <span class="text-black-300 mx-2 text-sm">{{item.name}}</span>

                        </li>
                    </ul>

                </ng-container>



            </div>

            <div
                class="lg:w-[90%] w-full  mx-auto border border-top pt-3 lg:absolute fixed bottom-0 hidden bg-white  lg:flex">
                <div class="flex flex-col w-[50%] text-sm text-black-300 "
                    *ngIf="modalData?.infoRooms?.roomPrice?.price">
                    <p class="flex items-center">
                        <span class="text-black-200 text-xs">{{modalData?.infoRooms?.roomPrice?.price?.nights}}
                            شب</span>
                        <span class="text-black-500 mx-1 text-xl">{{modalData?.infoRooms?.roomPrice?.price?.ihoPrice |
                            toToman | number: '2.'}}</span>
                        <span class="text-black-200 text-xs">تومان</span>
                    </p>
                </div>
                <button (click)="closeModal()" mat-flat-button color="primary"
                    class=" {{modalData?.infoRooms?.roomPrice?.price ? 'w-[50%]' :'w-full'}} !h-11">
                    مشاهده اتاق ها
                </button>
            </div>
            <div class="w-full fixed bottom-0 right-0 px-4 bg-white py-3 border border-top block lg:hidden">
                <button (click)="closeModal()" mat-flat-button color="primary" class="w-full !h-11">
                    رزرو اتاق
                </button>
            </div>
        </div>
    </div>
</div>
<ng-template #loading>
    <div class="w-full h-full flex justify-center items-center">
        <iho-loading></iho-loading>
    </div>
</ng-template>